import { styled, Box, Tab, Typography, Stack, Grid } from '../../base';
import { TOP_HEADER_HEIGHT } from '../../common';

export const StyledReportsPageWrapper = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(3),
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
    overflow: 'hidden',
}));

export const StyledTitleRow = styled(Grid)({
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
    fontSize: 20,
    color: theme.palette.common.black,
}));

export const StyledDate = styled(Typography)(({ theme }) => ({
    fontSize: 16,
    color: theme.palette.grey[600],
}));

export const StyledReportsContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    boxShadow: theme.shadows[24],
    borderRadius: theme.shape.borderRadius,
}));

export const StyledTab = styled(Tab, {
    shouldForwardProp: (prop) => prop !== 'isLast',
})<{ isLast?: boolean }>(({ isLast, theme }) => ({
    fontSize: 14,
    width: '100%',
    justifyContent: 'flex-start',
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
    '&:hover': {
        borderColor: theme.palette.divider,
    },
    '&.Mui-selected': {
        color: theme.palette.text.primary,
    },
}));

export const StyledMainArea = styled(Box)(({ theme }) => ({
    flex: 1,
    backgroundColor: theme.palette.common.white,
    overflowY: 'auto',
    overflowX: 'hidden',
}));
